import Highway from '@dogstudio/highway';
import WknPlyr from '../modules/wkn-plyr';
import { mouseMovefn } from 'utils.js';
export default class laMarqueRenderer extends Highway.Renderer {

	onEnter() {

		this.DOM = { view: this.wrap.lastElementChild };

		var swiper50Years = new Swiper('.fifty-years__swiper', {
			// Optional parameters
			loop: false,
			slidesPerView: "auto",
			spaceBetween: 20,
			breakpoints: {
				992: {
					spaceBetween: 50
				}
			},
		})


		const director__player = new Plyr('#video__director .video__player', {});
		director__player.on('play', event => {
			document.querySelector('#video__director .plyr__video__poster').classList.add('playing');
		});
		director__player.on('pause', event => {
			document.querySelector('#video__director .plyr__video__poster').classList.remove('playing');
		});

		
		const headquarters__player = new Plyr('#video__headquarters .video__player');
		headquarters__player.on('play', event => {
			document.querySelector('#video__headquarters .plyr__video__poster').classList.add('playing');
		});
		headquarters__player.on('pause', event => {
			document.querySelector('#video__headquarters .plyr__video__poster').classList.remove('playing');
		});


	}

}
